import { http } from './http';

export async function listPlanExtract(params = {}) {
  const { data } = await http.get('book/events/', { params });
  return data;
}

export async function getPlanExtractItem(id) {
  const { data } = await http.get(`book/events/${id}/`);
  return data;
}

export async function createPlanExtractItem(payload) {
  const { data } = await http.post('book/events/', payload);
  return data;
}

export async function updatePlanExtractItem(id, payload) {
  const { data } = await http.patch(`book/events/${id}/`, payload);
  return data;
}

export async function deletePlanExtractItem(id) {
  const { data } = await http.delete(`book/events/${id}/`);
  return data;
}

